<h1 *ngIf="i == 1">Applicant</h1>
<h1 *ngIf="i>1">Co-Applicant</h1>
<button (click)="goToNext()">Continue</button>
<button (click)="onCancel()">Cancel</button>